import { render, staticRenderFns } from "./InsertionBDD.vue?vue&type=template&id=130ea802&scoped=true&"
import script from "./InsertionBDD.vue?vue&type=script&lang=js&"
export * from "./InsertionBDD.vue?vue&type=script&lang=js&"
import style0 from "./InsertionBDD.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InsertionBDD.vue?vue&type=style&index=1&id=130ea802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ea802",
  null
  
)

export default component.exports